/**
 * QuietDiagnosticsProvider — a tiny shared "errors only" flag, lifted ABOVE the
 * shared model compile so suppression happens at the emission seam, not
 * per-representation.
 *
 * On a quick sketch (the scratch surface), TODO + warning diagnostics (incl.
 * graph warnings) are noise. Rather than each surface (editor squiggles, board
 * `!` badges, minimap, details) filtering them itself, `WorkspaceModelProvider`
 * reads this flag and strips them from the ONE compiled model every surface
 * consumes — so they're never emitted downstream.
 *
 * The flag's truth lives here; a surface (see `ViewerSurface`) drives it via
 * `setQuiet` as the user enters/leaves it.
 */
import { useMemo, useState, type ReactNode } from "react";
import { QuietDiagnosticsContext, type QuietDiagnostics } from "./QuietDiagnosticsContext.js";

export function QuietDiagnosticsProvider({ children }: { readonly children: ReactNode }) {
  const [quiet, setQuiet] = useState(false);
  const value = useMemo<QuietDiagnostics>(() => ({ quiet, setQuiet }), [quiet]);
  return (
    <QuietDiagnosticsContext.Provider value={value}>{children}</QuietDiagnosticsContext.Provider>
  );
}
